<template>
  <div>
    <div class="vx-row">
      <!-- COLUNA ESQUERDA -->
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <h5 class="mb-6">Valores Totais:</h5>
        <div>
          <h6 class="font-bold">Veículos:</h6>

          <!-- VEICULO MENSALIDADE -->
          <div class="flex justify-between items-center my-2">
            <div>
              Soma <span class="font-semibold">Mensalidade</span> veículos:
              <span class="font-bold">{{
                veiculoTotalTipoProdutoMensalidade | currency
              }}</span>
            </div>
            <div class="flex justify-end" v-if="liberaAcrescimoDesconto">
              <vs-button
                class="mr-2"
                color="success"
                @click="
                  changeModalAcrescimo({
                    valorTotal: veiculoTotalTipoProdutoMensalidade,
                    isMultiProposta: true,
                    qtdProdutos: veiculoQtdProdutosTipoMensalidade,
                    tipoValor: 'mensalidade',
                    tipoVeiculo: 'veiculo',
                    valorTotalOriginal:
                      veiculoTotalTipoProdutoMensalidadeOriginal,
                  })
                "
                >+</vs-button
              >
              <vs-button
                color="dark"
                @click="changeModalDesconto(tipoProdutoMensalidade, 'veiculo')"
              >
                %
              </vs-button>
            </div>
          </div>

          <!-- VEICULO ENTRADA/ADESÃO -->
          <div class="flex justify-between items-center">
            <div>
              Soma
              <span class="font-semibold">Primeira Parcela</span> veículos:
              <span class="font-bold">{{
                veiculoTotalTipoProdutoAdesao | currency
              }}</span>
            </div>
            <div class="flex justify-end" v-if="liberaAcrescimoDesconto">
              <vs-button
                class="mr-2"
                color="success"
                @click="
                  changeModalAcrescimo({
                    valorTotal: veiculoTotalTipoProdutoAdesao,
                    isMultiProposta: true,
                    qtdProdutos: veiculoQtdProdutosTipoAdesao,
                    tipoValor: 'entrada',
                    tipoVeiculo: 'veiculo',
                    valorTotalOriginal: veiculoTotalTipoProdutoAdesaoOriginal,
                  })
                "
                >+</vs-button
              >
              <vs-button
                color="dark"
                @click="changeModalDesconto(tipoProdutoAdesao, 'veiculo')"
              >
                %
              </vs-button>
            </div>
          </div>
        </div>

        <hr class="my-2" />

        <!-- AGREGADO MENSALIDADE -->
        <div
          class="mt-5"
          v-if="
            agregadoQtdProdutosTipoMensalidade > 0 ||
            agregadoQtdProdutosTipoAdesao > 0
          "
        >
          <h6 class="font-bold">Agregados:</h6>

          <div
            class="flex justify-between items-center my-2"
            v-if="agregadoQtdProdutosTipoMensalidade > 0"
          >
            <div>
              Soma <span class="font-semibold">Mensalidade</span> agregados:
              <span class="font-bold">{{
                agregadoTotalTipoProdutoMensalidade | currency
              }}</span>
            </div>
            <div class="flex justify-end">
              <vs-button
                class="mr-2"
                color="success"
                @click="
                  changeModalAcrescimo({
                    valorTotal: agregadoTotalTipoProdutoMensalidade,
                    isMultiProposta: true,
                    qtdProdutos: agregadoQtdProdutosTipoMensalidade,
                    tipoValor: 'mensalidade',
                    tipoVeiculo: 'agregado',
                    valorTotalOriginal:
                      agregadoTotalTipoProdutoMensalidadeOriginal,
                  })
                "
                >+</vs-button
              >
              <vs-button
                color="dark"
                @click="changeModalDesconto(tipoProdutoMensalidade, 'agregado')"
              >
                %
              </vs-button>
            </div>
          </div>

          <!-- AGREGADO ENTRADA/ADESÃO -->
          <div
            class="flex justify-between items-center"
            v-if="agregadoQtdProdutosTipoAdesao > 0"
          >
            <div>
              Soma
              <span class="font-semibold">Primeira Parcela</span> agregados:
              <span class="font-bold">{{
                agregadoTotalTipoProdutoAdesao | currency
              }}</span>
            </div>
            <div class="flex justify-end">
              <vs-button
                class="mr-2"
                color="success"
                @click="
                  changeModalAcrescimo({
                    valorTotal: agregadoTotalTipoProdutoAdesao,
                    isMultiProposta: true,
                    qtdProdutos: agregadoQtdProdutosTipoAdesao,
                    tipoValor: 'entrada',
                    tipoVeiculo: 'agregado',
                    valorTotalOriginal: agregadoTotalTipoProdutoAdesaoOriginal,
                  })
                "
                >+</vs-button
              >
              <vs-button
                color="dark"
                @click="changeModalDesconto(tipoProdutoAdesao, 'agregado')"
              >
                %
              </vs-button>
            </div>
          </div>
          <hr class="my-2" />
        </div>

        <!-- VALORES TOTAIS -->
        <h6 class="mt-5">
          Total Mensal:
          {{ valorTotalFinalMensal | currency }}
        </h6>
        <h6 class="mt-5">
          Total Entrada:
          {{ valorTotalFinalEntrada | currency }}
        </h6>
      </div>

      <!-- FORMAS DE PAGAMENTO -->
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <h5 class="mb-5">Formas de Pagamento:</h5>

        <!-- PRODUTOS MENSAIS -->
        <ul>
          <li
            class="mb-2"
            v-for="produto in listaProdutosMensais"
            :key="produto.id"
          >
            <label for="" class="vs-select--label">{{
              produto.nomeProduto
            }}</label>
            <v-select
              :options="produto.formas"
              :name="produto.nomeProduto"
              :id="produto.nomeProduto"
              @input="
                verificaCartaoCredito(produto),
                  defineTipoPagamentoProdutos(produto, 'mensal')
              "
              v-model="produto.valorFinal"
              label="text"
              :reduce="(produto) => produto.value"
              v-validate="{ required: true }"
              :state="validateState(produto.nomeProduto)"
              :class="validateClass(produto.nomeProduto)"
            ></v-select>
          </li>
        </ul>

        <!-- PRODUTOS À VISTA -->
        <ul>
          <li
            class="mb-2"
            v-for="produto in listaProdutosAVista"
            :key="produto.id"
          >
            <label for="" class="vs-select--label">{{
              produto.nomeProduto
            }}</label>
            <v-select
              :options="produto.formas"
              :name="produto.nomeProduto"
              :id="produto.nomeProduto"
              @input="
                verificaCartaoCredito(produto),
                  defineTipoPagamentoProdutos(produto, 'adesao')
              "
              v-model="produto.valorFinal"
              label="text"
              :reduce="(produto) => produto.value"
              v-validate="{ required: true }"
              :state="validateState(produto.nomeProduto)"
              :class="validateClass(produto.nomeProduto)"
            ></v-select>
          </li>
        </ul>
      </div>
    </div>

    <!-- MODAL NOVO VALOR PRODUTO -->
    <vs-popup :title="'Novo Valor Produto'" :active.sync="modalFormNovoValor">
      <formNovoValorProduto
        :configValorMulti="configValorMulti"
        :key="counterFormNovoValor"
        @close="modalFormNovoValor = false"
        @alteraValor="alteraAcrescimo"
      ></formNovoValorProduto>
    </vs-popup>

    <!-- MODAL DESCONTO -->
    <vs-popup
      title="Desconto"
      :active.sync="modalFormDesconto"
      @close="modalFormDesconto = false"
    >
      <formDesconto
        :key="counterFormDesconto"
        :dados="configDesconto"
        :contador="counterFormDesconto"
        :modal="modalFormDesconto"
        :decoded="tokenDecoded"
        @salvarDesconto="alteraDesconto"
      >
      </formDesconto>
    </vs-popup>

    <!-- MODAL CARTÃO DE CRÉDITO -->
    <!-- <vs-popup title="Dados do Cartão" :active.sync="modalFormCartaoCredito">
      <formCartaoCredito
        @adicionar="adicionarCartaoLista"
        :idProspect="idProspect"
        :typeCard="isCartaoMensal ? 'isCartaoMensal' : 'isCartaoAvista'"
      ></formCartaoCredito>
    </vs-popup> -->
  </div>
</template>

<script>
import formDesconto from '../../../../forms/formDesconto.vue';
import formNovoValorProduto from '../../../../forms/FormNovoValorProduto.vue';
import {
  agregadoMultiUpdateProdutoValorMinimoMensalidade,
  veiculoMultiUpdateProdutoValorMinimoMensalidade,
} from '../../../../../services/propostas';
import vSelect from 'vue-select';
import service from '../../../../../services/index';
// import cartaoCredito from '../../../../forms/FormCartaoCredito.vue';
import { TIPO_PRODUTO } from '../../../../../commons/dicionarioTipoProduto';
import { deepClone } from '../../../../../utils/deepClone';

export default {
  props: ['tokenDecoded', 'propostas', 'idProspect'],

  components: {
    'v-select': vSelect,
    formDesconto,
    formNovoValorProduto,
    // formCartaoCredito: cartaoCredito,
  },

  data() {
    return {
      //Listas
      listaProdutosSelecionadosUnicos: [],
      listaProdutosMensais: [],
      listaProdutosAVista: [],
      listaCartoes: [],
      propostasProdutosSelecionadosOriginais: [],
      propostasProdutosSelecionadosAtualizados: [],
      listaCopiaPropostas: [],

      //Modais
      modalFormDesconto: false,
      modalFormNovoValor: false,
      modalFormCartaoCredito: false,

      //Configs
      configValorMulti: {
        valorTotal: 0,
        isMultiProposta: true,
        qtdProdutos: 0,
        tipoValor: '',
        tipoVeiculo: '',
        valorTotalOriginal: 0,
      },
      configDesconto: null,
      tipoVeiculoDesconto: null,
      isCartaoAvista: null,
      isCartaoMensal: null,
      valorMensalidadeAtualParaDesconto: 0,
      liberaAcrescimoDesconto: false,

      //Contadores
      counterFormDesconto: 0,
      counterFormNovoValor: 0,

      dadosFinanceiros: {
        mensais: null,
        avista: null,
      },

      // Veículos
      veiculoTotalPagamentoMensal: 0,
      veiculoTotalPagamentoEntrada: 0,

      veiculoTotalTipoProdutoMensalidade: 0,
      veiculoTotalTipoProdutoAdesao: 0,

      veiculoTotalTipoProdutoMensalidadeOriginal: 0,
      veiculoTotalTipoProdutoAdesaoOriginal: 0,

      veiculoQtdProdutosTipoAdesao: 0,
      veiculoQtdProdutosTipoMensalidade: 0,

      //Agregados
      agregadoTotalPagamentoMensal: 0,
      agregadoTotalPagamentoEntrada: 0,

      agregadoTotalTipoProdutoMensalidade: 0,
      agregadoTotalTipoProdutoAdesao: 0,

      agregadoTotalTipoProdutoMensalidadeOriginal: 0,
      agregadoTotalTipoProdutoAdesaoOriginal: 0,

      agregadoQtdProdutosTipoAdesao: 0,
      agregadoQtdProdutosTipoMensalidade: 0,

      //Valor final
      valorTotalFinalMensal: 0,
      valorTotalFinalEntrada: 0,

      //Tipos de produto
      tipoProdutoAdesao: TIPO_PRODUTO.TIPO_PRODUTO_ADESAO,
      tipoProdutoMensalidade: TIPO_PRODUTO.TIPO_PRODUTO_MENSALIDADE,

      //Valores para acréscimo
      novoValorVeiculoMensalidade: 0,
      novoValorVeiculoEntrada: 0,
      novoValorAgregadoMensalidade: 0,
      novoValorAgregadoEntrada: 0,
    };
  },

  watch: {
    /**
     * Caso o modal desconto seja fechado, limpa o valor base para alteração do desconto
     * @param {boolean} novoValor o novo valor da variável
     */
    modalFormDesconto(novoValor) {
      if (!novoValor) {
        this.configDesconto = null;
      }
    },

    /**
     * Caso o modal novo valor seja fechado, limpa o base para alteração do acréscimo
     * @param {boolean} novoValor o novo valor da variável
     */
    modalFormNovoValor(novoValor) {
      if (!novoValor) {
        this.configValorMulti = null;
      }
    },

    /**
     * Monitora alterações profundas no objeto propostasProdutosSelecionadosAtualizados e emite um evento para o componente pai com o novo valor.
     * @param {any} novoValor O novo valor do objeto propostasProdutosSelecionadosAtualizados.
     */
    propostasProdutosSelecionadosAtualizados: {
      handler(propostasProdutos) {
        const propostasAtualizadasComNovosDadosProdutos =
          this.salvaProdutosAtualizadosNasPropostas(propostasProdutos);

        this.$emit(
          'submitDadosFormasPagamento',
          propostasAtualizadasComNovosDadosProdutos,
        );
      },
      deep: true, // Monitora alterações profundas no objeto
    },
  },

  methods: {
    /**
     * Adiciona as alterações salvas dos produtos e dados financeiros em uma cópia das propostas e retorna essa cópia alterada
     * @param {Array{Object}} propostasProdutos - O array de propostas com os produtos manipulados
     * @return {Array{Object}} - Array de propostas completo com as alterações realizadas
     */
    salvaProdutosAtualizadosNasPropostas(propostaProdutos) {
      const propostasComNovosDadosProdutos = this.listaCopiaPropostas.map(
        (proposta, propostaIndex) => {
          propostaProdutos.forEach((propostaProduto, produtoIndex) => {
            if (propostaIndex === produtoIndex) {
              proposta.produtosSelecionados = propostaProduto.produtosVeiculo;
            }
          });

          proposta.dadosFinanceiros = this.dadosFinanceiros;

          proposta.agregados.forEach((agregado, agregadoIndex) => {
            propostaProdutos.forEach((propostaProduto, produtoIndex) => {
              if (agregadoIndex === produtoIndex) {
                agregado.produtosSelecionados = propostaProduto.produtosVeiculo;
                agregado.dadosFinanceiros = this.dadosFinanceiros;
              }
            });
          });

          return proposta;
        },
      );

      return propostasComNovosDadosProdutos;
    },

    /**
     * Define o exemplo de um produto específico com base no tipo de produto e no tipo de veículo.
     * @param {number} idTipoProduto - O ID do tipo de produto.
     * @param {string} tipoVeiculo - O tipo de veículo ('veiculo' ou 'agregado').
     * @return {Object|null} O produto do tipo especificado encontrado nas propostas, ou null se não encontrado.
     */
    defineProdutoExemplo(idTipoProduto, tipoVeiculo) {
      let produtoTipoEspecifico = null;

      if (tipoVeiculo === 'veiculo') {
        this.propostasProdutosSelecionadosOriginais.forEach((proposta) => {
          const produtoVeiculoEncontrado = proposta.produtosVeiculo.find(
            (produtoVeiculo) => produtoVeiculo.id_tipoProduto === idTipoProduto,
          );
          if (produtoVeiculoEncontrado) {
            produtoTipoEspecifico = produtoVeiculoEncontrado;
            return;
          }
        });
      }

      if (tipoVeiculo === 'agregado') {
        this.propostasProdutosSelecionadosOriginais.forEach((proposta) => {
          proposta.agregados.forEach((agregado) => {
            const produtoAgregadoEncontrado = agregado.produtosAgregado.find(
              (produtoAgregado) =>
                produtoAgregado.id_tipoProduto === idTipoProduto,
            );
            if (produtoAgregadoEncontrado) {
              produtoTipoEspecifico = produtoAgregadoEncontrado;
              return;
            }
          });
        });
      }
      return produtoTipoEspecifico;
    },

    /**
     * Altera a configuração de desconto e exibe ou oculta o formulário de desconto.
     * @param {number} idTipoProduto - O ID do tipo de produto.
     * @param {string} tipoVeiculo - O tipo de veículo ('veiculo' ou 'agregado').
     */
    changeModalDesconto(idTipoProduto, tipoVeiculo) {
      this.tipoVeiculoDesconto = tipoVeiculo;

      const produtoExemplo = this.defineProdutoExemplo(
        idTipoProduto,
        tipoVeiculo,
      );

      const valorOriginalParaDesconto =
        this.defineTipoValorOriginalParaDesconto(idTipoProduto, tipoVeiculo);

      const valorOriginalMensalidadeParaDeconto =
        this.defineTipoValorOriginalParaDesconto(
          this.tipoProdutoMensalidade,
          tipoVeiculo,
        );

      this.configDesconto = {
        ...produtoExemplo,
        valor: valorOriginalParaDesconto,
        valorFinal: valorOriginalParaDesconto,
        estado: this.listaCopiaPropostas[0].estado,
        tipoProposta: this.listaCopiaPropostas[0].tipoProposta,
        valorFipe:
          this.listaCopiaPropostas[0].precoVeiculo ||
          this.listaCopiaPropostas[0].valorFipe,
        valorMensalidade: this.valorMensalidadeAtualParaDesconto
          ? this.valorMensalidadeAtualParaDesconto
          : valorOriginalMensalidadeParaDeconto,
      };

      const valorMensalidadeVeiculoJaFoiAlterado =
        this.novoValorVeiculoMensalidade > 0;
      const valorMensalidadeAgregadoJaFoiAlterado =
        this.novoValorAgregadoMensalidade > 0;
      const valorEntradaVeiculoJaFoiAlterado = this.novoValorVeiculoEntrada > 0;
      const valorEntradaAgregadoJaFoiAlterado =
        this.novoValorAgregadoEntrada > 0;

      if (
        valorMensalidadeVeiculoJaFoiAlterado &&
        tipoVeiculo === 'veiculo' &&
        idTipoProduto === this.tipoProdutoMensalidade
      ) {
        this.configDesconto.valor = this.novoValorVeiculoMensalidade;
        this.configDesconto.valorMensalidade = this.novoValorVeiculoMensalidade;
      }

      if (
        valorMensalidadeVeiculoJaFoiAlterado &&
        tipoVeiculo === 'veiculo' &&
        idTipoProduto === this.tipoProdutoAdesao
      ) {
        this.configDesconto.valor = valorEntradaVeiculoJaFoiAlterado
          ? this.novoValorVeiculoEntrada
          : this.configDesconto.valor;
        this.configDesconto.valorMensalidade =
          valorMensalidadeVeiculoJaFoiAlterado
            ? this.novoValorVeiculoMensalidade
            : this.configDesconto.valorMensalidade;
      }

      if (
        valorMensalidadeAgregadoJaFoiAlterado &&
        tipoVeiculo === 'agregado' &&
        idTipoProduto === this.tipoProdutoMensalidade
      ) {
        this.configDesconto.valor = this.novoValorAgregadoMensalidade;
        this.configDesconto.valorMensalidade =
          this.novoValorAgregadoMensalidade;
      }

      if (
        valorMensalidadeAgregadoJaFoiAlterado &&
        tipoVeiculo === 'agregado' &&
        idTipoProduto == this.tipoProdutoAdesao
      ) {
        this.configDesconto.valor = valorEntradaAgregadoJaFoiAlterado
          ? this.novoValorAgregadoEntrada
          : this.configDesconto.valor;
        this.configDesconto.valorMensalidade =
          valorMensalidadeAgregadoJaFoiAlterado
            ? this.novoValorAgregadoMensalidade
            : this.configDesconto.valorMensalidade;
      }

      this.modalFormDesconto = !this.modalFormDesconto;
      this.counterFormDesconto++;
    },

    /**
     * Retorna o valor original do tipo de produto para desconto com base no ID do tipo de produto e no tipo de veículo.
     * @param {number} idTipoProduto - O ID do tipo de produto.
     * @return {number} O valor original do tipo de produto para desconto.
     */
    defineTipoValorOriginalParaDesconto(idTipoProduto) {
      const mapeamento = {
        [`${this.tipoProdutoAdesao}_veiculo`]:
          this.veiculoTotalTipoProdutoAdesaoOriginal,
        [`${this.tipoProdutoMensalidade}_veiculo`]:
          this.veiculoTotalTipoProdutoMensalidadeOriginal,
        [`${this.tipoProdutoAdesao}_agregado`]:
          this.agregadoTotalTipoProdutoAdesaoOriginal,
        [`${this.tipoProdutoMensalidade}_agregado`]:
          this.agregadoTotalTipoProdutoMensalidadeOriginal,
      };

      const chave = `${idTipoProduto}_${this.tipoVeiculoDesconto}`;
      return mapeamento[chave];
    },

    /** Retorna o novo valor pós acréscimo do tipo de produto com base no veículo
     * @param {string} tipoValor - 'mensalidade' ou 'entrada'
     * @param {string} tipoVeiculo - 'veiculo' ou 'agregado'
     */
    buscaTipoValorNovoParaAcrescimo(tipoValor, tipoVeiculo) {
      const mapeamento = {
        mensalidade_veiculo: this.novoValorVeiculoMensalidade,
        entrada_veiculo: this.novoValorVeiculoEntrada,
        mensalidade_agregado: this.novoValorAgregadoMensalidade,
        entrada_agregado: this.novoValorAgregadoEntrada,
      };

      const chave = `${tipoValor}_${tipoVeiculo}`;

      return mapeamento[chave];
    },

    /**
     * Atualiza a configuração do novo valor e controla o estado do modal de novo valor.
     * @param {Object} configValorMulti - A configuração do novo valor a ser atualizado.
     */
    changeModalAcrescimo(configValorMulti) {
      this.configValorMulti = configValorMulti;
      const { tipoValor, tipoVeiculo, valor } = this.configValorMulti;

      const novoValorPosAcrescimo = this.buscaTipoValorNovoParaAcrescimo(
        tipoValor,
        tipoVeiculo,
      );

      this.configValorMulti.valor = novoValorPosAcrescimo
        ? novoValorPosAcrescimo
        : valor;
      this.modalFormNovoValor = !this.modalFormNovoValor;
      this.counterFormNovoValor++;
    },

    /**
     * Atualiza o valor final dos produtos de acordo com a configuração do novo valor e recalcula os valores totais.
     * @param {Object} novoValorConfig - Configuração do novo valor a ser aplicado.
     * @param {string} novoValorConfig.tipoValor - Tipo de valor ('mensalidade' ou 'adesao').
     * @param {string} novoValorConfig.tipoVeiculo - Tipo de veículo ('veiculo' ou 'agregado').
     * @param {number} novoValorConfig.valorRateado - Novo valor rateado a ser aplicado.
     */
    alteraAcrescimo(novoValorConfig) {
      const { tipoValor, tipoVeiculo, valorRateado, valor } = novoValorConfig;

      if (tipoVeiculo === 'veiculo' && tipoValor === 'mensalidade') {
        this.novoValorVeiculoMensalidade = valor;
      }

      if (tipoVeiculo === 'veiculo' && tipoValor === 'entrada') {
        this.novoValorVeiculoEntrada = valor;
      }

      if (tipoVeiculo === 'agregado' && tipoValor === 'mensalidade') {
        this.novoValorAgregadoMensalidade = valor;
      }

      if (tipoVeiculo === 'agregado' && tipoValor === 'entrada') {
        this.novoValorAgregadoEntrada = valor;
      }

      const tipoProdutoAlvo =
        tipoValor === 'mensalidade'
          ? this.tipoProdutoMensalidade
          : this.tipoProdutoAdesao;

      const copiaPropostasProdutosSelecionadosOriginais = [
        ...this.propostasProdutosSelecionadosOriginais,
      ];

      if (tipoVeiculo === 'veiculo') {
        copiaPropostasProdutosSelecionadosOriginais.forEach((proposta) => {
          proposta.produtosVeiculo.forEach((produtoVeiculo) => {
            if (produtoVeiculo.id_tipoProduto === tipoProdutoAlvo) {
              produtoVeiculo.valorFinal = valorRateado;
            }
          });
        });
      }

      if (tipoVeiculo === 'agregado') {
        copiaPropostasProdutosSelecionadosOriginais.forEach((proposta) => {
          proposta.agregados.forEach((agregado) => {
            agregado.produtosAgregado.forEach((produtoAgregado) => {
              if (produtoAgregado.id_tipoProduto === tipoProdutoAlvo) {
                produtoAgregado.valorFinal = valorRateado;
              }
            });
          });
        });
      }

      this.propostasProdutosSelecionadosAtualizados =
        copiaPropostasProdutosSelecionadosOriginais;

      this.calculaValoresTotais(this.propostasProdutosSelecionadosAtualizados);
    },

    /**
     * Retorna a quantidade de produtos para desconto com base no tipo de produto e no tipo de veículo.
     * @param {string} idTipoProduto - O ID do tipo de produto.
     * @returns {number} A quantidade de produtos para desconto.
     */
    defineQtdProdutosParaDesconto(idTipoProduto) {
      const mapeamento = {
        [`${this.tipoProdutoAdesao}_veiculo`]:
          this.veiculoQtdProdutosTipoAdesao,
        [`${this.tipoProdutoMensalidade}_veiculo`]:
          this.veiculoQtdProdutosTipoMensalidade,
        [`${this.tipoProdutoAdesao}_agregado`]:
          this.agregadoQtdProdutosTipoAdesao,
        [`${this.tipoProdutoMensalidade}_agregado`]:
          this.agregadoQtdProdutosTipoMensalidade,
      };

      const chave = `${idTipoProduto}_${this.tipoVeiculoDesconto}`;
      return mapeamento[chave];
    },

    /**
     * Aplica desconto no valor total da mensalidade ou da entrada nas propostas.
     * @param {Object} descontoConfig - Configuração do desconto contendo informações sobre o produto e o desconto aplicado.
     * @param {number} descontoConfig.valorFinal - O valor final da soma de todos os produtos.
     * @param {number} descontoConfig.valorDesconto - O valor do desconto aplicado.
     * @param {number} descontoConfig.descontoConcedido - O valor total do desconto concedido.
     * @param {string} descontoConfig.tipoDesconto - O tipo de desconto aplicado.
     * @param {string} descontoConfig.idTipoDesconto - O ID do tipo de desconto.
     * @param {string} descontoConfig.id_tipoProduto - O ID do tipo de produto.
     * @param {number} descontoConfig.valorMensalidade - O valor total da mensalidade.
     */
    alteraDesconto(descontoConfig) {
      const {
        valorFinal: valorPosDesconto,
        valorDesconto,
        descontoConcedido,
        tipoDesconto,
        idTipoDesconto,
        id_tipoProduto,
        valorMensalidade,
      } = descontoConfig;

      const descontoInfo = {};

      const qtdProdutos = this.defineQtdProdutosParaDesconto(id_tipoProduto);

      const valorFinalPorProduto = valorPosDesconto / qtdProdutos;
      const valorDescontoPorProduto = valorDesconto / qtdProdutos;
      const valorMensalidadePorProduto = valorMensalidade / qtdProdutos;

      const isValorFinalMenorQueMensalidade =
        valorPosDesconto < valorMensalidade;

      const isValorDescontoMenorQueMensalidade =
        valorDesconto < valorMensalidade;

      descontoInfo.valorFinal = isValorFinalMenorQueMensalidade
        ? valorMensalidadePorProduto
        : valorFinalPorProduto;
      descontoInfo.valorDesconto = isValorDescontoMenorQueMensalidade
        ? valorMensalidadePorProduto
        : valorDescontoPorProduto;
      descontoInfo.tipoDesconto = tipoDesconto;
      descontoInfo.idTipoDesconto = idTipoDesconto;
      descontoInfo.id_tipoProduto = id_tipoProduto;
      descontoInfo.style =
        this.valorDesconto === 0 ? null : 'text-decoration: line-through;';
      descontoInfo.isDesconto = false;
      descontoInfo.descontoConcedido =
        this.valorDesconto === 0 ? 0 : descontoConcedido;

      if (id_tipoProduto === this.tipoProdutoMensalidade) {
        descontoInfo.valorFinal = valorFinalPorProduto;
        descontoInfo.valorDesconto = valorFinalPorProduto;

        this.valorMensalidadeAtualParaDesconto = valorFinalPorProduto;
      }

      if (
        id_tipoProduto === this.tipoProdutoAdesao &&
        this.valorMensalidadeAtualParaDesconto
      ) {
        descontoInfo.valorFinal = this.valorMensalidadeAtualParaDesconto;
      }

      if (this.tipoVeiculoDesconto === 'veiculo') {
        this.propostasProdutosSelecionadosAtualizados.forEach((proposta) => {
          proposta.produtosVeiculo.forEach((produtoVeiculo) => {
            if (produtoVeiculo.id_tipoProduto === descontoInfo.id_tipoProduto) {
              Object.assign(produtoVeiculo, descontoInfo);
            }
          });
        });
      }

      if (this.tipoVeiculoDesconto === 'agregado') {
        this.propostasProdutosSelecionadosAtualizados.forEach((proposta) => {
          proposta.agregados.forEach((agregado) => {
            agregado.produtosAgregado.forEach((produtoAgregado) => {
              if (
                produtoAgregado.id_tipoProduto === descontoInfo.id_tipoProduto
              ) {
                Object.assign(produtoAgregado, descontoInfo);
              }
            });
          });
        });
      }

      this.calculaValoresTotais(this.propostasProdutosSelecionadosAtualizados);
      this.modalFormDesconto = false;
      this.tipoVeiculoDesconto = '';
    },

    /**
     * Calcula e armazena os valores totais originais para tipos de produtos na proposta.
     * @param {array} propostaProdutosSelecionados - Lista de produtos selecionados em todas as propostas.
     */
    calculaValoresTotaisOriginais(propostaProdutosSelecionados) {
      const totalTipoProdutoAdesaoOriginal = this.somaValorTotalTipoProduto(
        propostaProdutosSelecionados,
        this.tipoProdutoAdesao,
      );
      const {
        veiculoValorTotalTipoProduto: veiculoValorTotalAdesao,
        agregadoValorTotalTipoProduto: agregadoValorTotalAdesao,
      } = totalTipoProdutoAdesaoOriginal;

      const totalTipoProdutoMensalidadeOriginal =
        this.somaValorTotalTipoProduto(
          propostaProdutosSelecionados,
          this.tipoProdutoMensalidade,
        );
      const {
        veiculoValorTotalTipoProduto: veiculoValorTotalMensalidade,
        agregadoValorTotalTipoProduto: agregadoValorTotalMensalidade,
      } = totalTipoProdutoMensalidadeOriginal;

      this.veiculoTotalTipoProdutoAdesaoOriginal = veiculoValorTotalAdesao;
      this.veiculoTotalTipoProdutoMensalidadeOriginal =
        veiculoValorTotalMensalidade;
      this.agregadoTotalTipoProdutoAdesaoOriginal = agregadoValorTotalAdesao;
      this.agregadoTotalTipoProdutoMensalidadeOriginal =
        agregadoValorTotalMensalidade;
    },

    /**
     * Calcula os valores totais para os tipos de produtos de adesão e mensalidade, bem como os valores totais de pagamento de entrada e mensalidade.
     * Verifica se o valor total do produto de adesão é menor que o total de pagamento mensal e, se for o caso, ajusta o valor do produto de adesão para igualar o total de pagamento mensal.
     * @param {Array} propostaProdutosSelecionados - Lista de propostas com seus produtos.
     */
    calculaValoresTotais(propostaProdutosSelecionados) {
      const totalTipoProdutoAdesao = this.somaValorTotalTipoProduto(
        propostaProdutosSelecionados,
        this.tipoProdutoAdesao,
      );
      const {
        veiculoValorTotalTipoProduto: veiculoValorTotalAdesao,
        agregadoValorTotalTipoProduto: agregadoValorTotalAdesao,
      } = totalTipoProdutoAdesao;

      const totalTipoProdutoMensalidade = this.somaValorTotalTipoProduto(
        propostaProdutosSelecionados,
        this.tipoProdutoMensalidade,
      );
      const {
        veiculoValorTotalTipoProduto: veiculoValorTotalMensalidade,
        agregadoValorTotalTipoProduto: agregadoValorTotalMensalidade,
      } = totalTipoProdutoMensalidade;

      this.veiculoTotalTipoProdutoAdesao = veiculoValorTotalAdesao;
      this.veiculoTotalTipoProdutoMensalidade = veiculoValorTotalMensalidade;
      this.agregadoTotalTipoProdutoAdesao = agregadoValorTotalAdesao;
      this.agregadoTotalTipoProdutoMensalidade = agregadoValorTotalMensalidade;

      const totalPagamentoEntrada = this.somaValorTotalPagamento(
        propostaProdutosSelecionados,
        'adesao',
      );
      const {
        veiculoValorTotal: veiculoValorTotalEntrada,
        agregadoValorTotal: agregadoValorTotalEntrada,
      } = totalPagamentoEntrada;

      const totalPagamentoMensalidade = this.somaValorTotalPagamento(
        propostaProdutosSelecionados,
        'mensal',
      );
      const {
        veiculoValorTotal: veiculoValorTotalMensal,
        agregadoValorTotal: agregadoValorTotalMensal,
      } = totalPagamentoMensalidade;

      this.veiculoTotalPagamentoEntrada = veiculoValorTotalEntrada;
      this.veiculoTotalPagamentoMensal = veiculoValorTotalMensal;
      this.agregadoTotalPagamentoEntrada = agregadoValorTotalEntrada;
      this.agregadoTotalPagamentoMensal = agregadoValorTotalMensal;

      this.valorTotalFinalEntrada =
        veiculoValorTotalEntrada + agregadoValorTotalEntrada;
      this.valorTotalFinalMensal =
        veiculoValorTotalMensal + agregadoValorTotalMensal;

      const veiculoTotalProdutoAdesaoMenorQueTotalDePagamentosMensais =
        this.veiculoTotalTipoProdutoAdesao < this.veiculoTotalPagamentoMensal;

      const agregadoTotalProdutoAdesaoMenorQueTotalDePagamentosMensais =
        this.agregadoTotalTipoProdutoAdesao < this.agregadoTotalPagamentoMensal;

      if (veiculoTotalProdutoAdesaoMenorQueTotalDePagamentosMensais) {
        this.propostasProdutosSelecionadosAtualizados =
          this.igualaProdutoAdesaoAoTotalPagamentoMensal('veiculo');

        this.calculaValoresTotais(
          this.propostasProdutosSelecionadosAtualizados,
        );

        this.$vs.notify({
          position: 'top-center',
          title: 'O valor da adesão foi reajustado',
          text: 'O valor da adesão não pode ser menor do que a mensalidade.',
          color: 'warning',
          timer: 10000,
        });
      }

      if (agregadoTotalProdutoAdesaoMenorQueTotalDePagamentosMensais) {
        this.propostasProdutosSelecionadosAtualizados =
          this.igualaProdutoAdesaoAoTotalPagamentoMensal('agregado');

        this.calculaValoresTotais(
          this.propostasProdutosSelecionadosAtualizados,
        );

        this.$vs.notify({
          position: 'top-center',
          title: 'O valor da adesão foi reajustado',
          text: 'O valor da adesão não pode ser menor do que a mensalidade.',
          color: 'warning',
          timer: 10000,
        });
      }
    },

    /**
     * Ajusta o valor do produto de adesão para que seja igual ao total de pagamento mensal.
     * @param {string} tipo - Tipo de veículo ('veiculo' ou 'agregado').
     * @returns {Array} - Lista de propostas e produtos atualizados com o valor mínimo de adesão ajustado.
     */
    igualaProdutoAdesaoAoTotalPagamentoMensal(tipo) {
      const totalPagamentoMensal =
        tipo === 'veiculo'
          ? this.veiculoTotalPagamentoMensal
          : this.agregadoTotalPagamentoMensal;
      const qtdProdutosTipoAdesao =
        tipo === 'veiculo'
          ? this.veiculoQtdProdutosTipoAdesao
          : this.agregadoQtdProdutosTipoAdesao;

      const valorMensalidadeRateadoPorQtdProduto = parseFloat(
        (totalPagamentoMensal / qtdProdutosTipoAdesao).toFixed(2),
      );

      const multiUpdateProdutoValorMinimoMensalidade =
        tipo === 'veiculo'
          ? veiculoMultiUpdateProdutoValorMinimoMensalidade
          : agregadoMultiUpdateProdutoValorMinimoMensalidade;

      const propostaProdutosAtualizadosMinimoAdesao =
        multiUpdateProdutoValorMinimoMensalidade(
          this.propostasProdutosSelecionadosAtualizados,
          valorMensalidadeRateadoPorQtdProduto,
          tipo,
        );

      return propostaProdutosAtualizadosMinimoAdesao;
    },

    /**
     * Soma os valores totais de pagamento de acordo com o tipo de produto e se é mensal ou não.
     * @param {Array} propostasProdutos - Lista de propostas com produtos.
     * @param {string} isMensal - Indica se o pagamento é mensal ('mensal') ou de entrada ('adesao').
     * @returns {Object} - Objeto contendo os valores totais de pagamento para veículos e agregados.
     */
    somaValorTotalPagamento(propostasProdutos, isMensal) {
      let veiculoValorTotal = 0;
      let agregadoValorTotal = 0;

      propostasProdutos.forEach((propostas) => {
        propostas.produtosVeiculo.forEach((produtoVeiculo) => {
          const condicaoIsMensal =
            isMensal === 'mensal'
              ? produtoVeiculo.ismensal
              : !produtoVeiculo.ismensal;
          if (condicaoIsMensal) {
            veiculoValorTotal += produtoVeiculo.valorFinal
              ? produtoVeiculo.valorFinal
              : produtoVeiculo.valor;
          }
        });

        propostas.agregados.forEach((agregado) => {
          agregado.produtosAgregado.forEach((produtoAgregado) => {
            const condicaoIsMensal =
              isMensal === 'mensal'
                ? produtoAgregado.ismensal
                : !produtoAgregado.ismensal;
            if (condicaoIsMensal) {
              agregadoValorTotal += produtoAgregado.valorFinal
                ? produtoAgregado.valorFinal
                : produtoAgregado.valor;
            }
          });
        });
      });

      return {
        veiculoValorTotal: parseFloat(veiculoValorTotal.toFixed(2)),
        agregadoValorTotal: parseFloat(agregadoValorTotal.toFixed(2)),
      };
    },

    /**
     * Soma os valores totais de um tipo específico de produto (veículo ou agregado) em todas as propostas.
     * @param {Array} propostasProdutos - Lista de propostas com produtos.
     * @param {string} idTipoProduto - ID do tipo de produto a ser somado.
     * @returns {Object} - Objeto contendo os valores totais do tipo de produto para veículos e agregados.
     */
    somaValorTotalTipoProduto(propostasProdutos, idTipoProduto) {
      let veiculoValorTotalTipoProduto = 0;
      let agregadoValorTotalTipoProduto = 0;

      propostasProdutos.forEach((propostas) => {
        propostas.produtosVeiculo.forEach((produtoVeiculo) => {
          if (produtoVeiculo.id_tipoProduto === idTipoProduto) {
            veiculoValorTotalTipoProduto += produtoVeiculo.valorFinal;
          }
        });
      });

      propostasProdutos.forEach((propostas) => {
        propostas.agregados.forEach((agregado) => {
          agregado.produtosAgregado.forEach((produtoAgregado) => {
            if (produtoAgregado.id_tipoProduto === idTipoProduto) {
              agregadoValorTotalTipoProduto += produtoAgregado.valorFinal;
            }
          });
        });
      });

      return {
        veiculoValorTotalTipoProduto: parseFloat(
          veiculoValorTotalTipoProduto.toFixed(2),
        ),
        agregadoValorTotalTipoProduto: parseFloat(
          agregadoValorTotalTipoProduto.toFixed(2),
        ),
      };
    },

    /**
     * Monta uma lista de produtos com suas respectivas formas de pagamento com base nas formas de pagamento fornecidas.
     * As formas de pagamento são agrupadas de acordo com o tipo de produto (mensal ou à vista).
     * @param {Object[]} formasPagamento - As formas de pagamento disponíveis.
     */
    montaListaProdutosFormasPagamento(formasPagamento) {
      formasPagamento.forEach((forma) => {
        const listaProdutosEscolhida = forma.isMensal
          ? this.listaProdutosMensais
          : this.listaProdutosAVista;

        let produtoExistente = listaProdutosEscolhida.find(
          (produto) => produto.idProduto === forma.idProduto,
        );

        if (!produtoExistente) {
          produtoExistente = {
            idProduto: forma.idProduto,
            nomeProduto: forma.nomeProduto,
            isMensal: forma.isMensal,
            valor: null,
            formas: [],
          };

          listaProdutosEscolhida.push(produtoExistente);
        }

        produtoExistente.formas.push({
          value: {
            idTipoPagamentoEmpresa: forma.id_tipoPagamentoEmpresa,
            tipoPagamento: forma.nomePagamento,
          },
          text: forma.nomePagamento,
        });
      });
    },

    /**
     * Monta uma lista de produtos selecionados únicos a partir das propostas de produtos selecionados originais.
     * Os produtos são agrupados e filtrados para garantir que apenas os produtos únicos sejam incluídos na lista, sem repetições.
     */
    montaProdutosSelecionadosUnicos() {
      const todosProdutos = [];

      this.propostasProdutosSelecionadosOriginais.forEach((propostas) => {
        todosProdutos.push(...propostas.produtosVeiculo);

        propostas.agregados.forEach((agregado) => {
          todosProdutos.push(...agregado.produtosAgregado);
        });
      });

      const produtosUnicos = todosProdutos.reduce(
        (produtosAcumulados, produtoAtual) => {
          const produtoJaExiste = produtosAcumulados.some(
            (produto) => produto.id_produto === produtoAtual.id_produto,
          );

          if (!produtoJaExiste) {
            produtosAcumulados.push(produtoAtual);
          }

          return produtosAcumulados;
        },
        [],
      );

      this.listaProdutosSelecionadosUnicos = produtosUnicos;
    },

    /**
     * Busca as formas de pagamento de acorto com a lista de todos os produtos, sem repetição, de todas as propostas.
     */
    async buscaFormasPagamento() {
      try {
        this.$vs.loading();

        const objSendRequest = {
          idEmpresa: this.tokenDecoded.id_empresa,
          idProspect: this.idProspect,
          produtos: this.listaProdutosSelecionadosUnicos,
          regional: { id: this.tokenDecoded.id_regional },
        };

        const resultFormasPagamentoEncontradas = await service.post(
          'CotacaoAberta',
          'buscaFormasPagamentoSemProposta',
          objSendRequest,
        );

        const formasPagamento =
          resultFormasPagamentoEncontradas.data.formasPagamento;

        this.listaCartoes = resultFormasPagamentoEncontradas.data.cartoes;

        this.montaListaProdutosFormasPagamento(formasPagamento);
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar os tipos de pagamento',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Monta as propostas de produtos selecionados com base nas propostas originais e atualiza as quantidades de produtos por tipo.
     */
    montaPropostasProdutosSelecionados() {
      this.propostasProdutosSelecionadosOriginais = [
        ...this.listaCopiaPropostas.map((proposta) => {
          return {
            placaChassiVeiculo: proposta.placa
              ? proposta.placa
              : proposta.chassi,
            produtosVeiculo: proposta.produtosSelecionados,
            agregados: proposta.agregados.map((agregado) => {
              return {
                placaAgregado: agregado.placa,
                produtosAgregado: agregado.produtosSelecionados,
              };
            }),
          };
        }),
      ];

      this.propostasProdutosSelecionadosAtualizados = [
        ...this.listaCopiaPropostas.map((proposta) => {
          return {
            placaChassiVeiculo: proposta.placa
              ? proposta.placa
              : proposta.chassi,
            produtosVeiculo: proposta.produtosSelecionados,
            agregados: proposta.agregados.map((agregado) => {
              return {
                placaAgregado: agregado.placa,
                produtosAgregado: agregado.produtosSelecionados,
              };
            }),
          };
        }),
      ];

      const qtdProdutosMensalidade = this.calculaQtdProdutos(
        this.propostasProdutosSelecionadosOriginais,
        this.tipoProdutoMensalidade,
      );

      const qtdProdutosAdesao = this.calculaQtdProdutos(
        this.propostasProdutosSelecionadosOriginais,
        this.tipoProdutoAdesao,
      );

      this.veiculoQtdProdutosTipoMensalidade =
        qtdProdutosMensalidade.qtdProdutosVeiculoPorTipo;
      this.agregadoQtdProdutosTipoMensalidade =
        qtdProdutosMensalidade.qtdProdutosAgregadoPorTipo;

      this.veiculoQtdProdutosTipoAdesao =
        qtdProdutosAdesao.qtdProdutosVeiculoPorTipo;
      this.agregadoQtdProdutosTipoAdesao =
        qtdProdutosAdesao.qtdProdutosAgregadoPorTipo;
    },

    /**
     * Calcula a quantidade de produtos de um determinado tipo em um array de propostas.
     * @param {Array<Array<Object>>} propostasProdutos - O array de propostas de produtos.
     * @param {number} idTipoProduto - O ID do tipo de produto a ser contado.
     * @returns {number} A quantidade de produtos do tipo especificado.
     */
    calculaQtdProdutos(propostasProdutos, idTipoProduto) {
      let qtdProdutosVeiculoPorTipo = 0;
      let qtdProdutosAgregadoPorTipo = 0;

      propostasProdutos.forEach((propostas) => {
        propostas.produtosVeiculo.forEach((produtoVeiculo) => {
          if (produtoVeiculo.id_tipoProduto === idTipoProduto) {
            qtdProdutosVeiculoPorTipo++;
          }
        });

        propostas.agregados.forEach((agregado) => {
          agregado.produtosAgregado.forEach((produtoAgregado) => {
            if (produtoAgregado.id_tipoProduto === idTipoProduto) {
              qtdProdutosAgregadoPorTipo++;
            }
          });
        });
      });
      return { qtdProdutosVeiculoPorTipo, qtdProdutosAgregadoPorTipo };
    },

    /**
     * Define o tipo de pagamento para os produtos com base no tipo de pagamento especificado.
     * @param {Object} objProdutoPagamento - Objeto contendo informações sobre o produto e seu pagamento.
     * @param {string} tipoPagamento - O tipo de pagamento ('mensal' para pagamento mensal ou 'adesao' para pagamento à vista).
     */
    defineTipoPagamentoProdutos(objProdutoPagamento, tipoPagamento) {
      if (tipoPagamento === 'mensal') {
        this.dadosFinanceiros.mensais = objProdutoPagamento.valorFinal;
      }

      if (tipoPagamento === 'adesao') {
        this.dadosFinanceiros.avista = objProdutoPagamento.valorFinal;
      }

      const novaListaPropostas =
        this.propostasProdutosSelecionadosAtualizados.map((proposta) => {
          const novaProposta = { ...proposta };
          novaProposta.produtosVeiculo = novaProposta.produtosVeiculo.map(
            (produtoVeiculo) => {
              const novoProdutoVeiculo = { ...produtoVeiculo };

              if (novoProdutoVeiculo.ismensal) {
                novoProdutoVeiculo.idTipoPagamentoEmpresa =
                  this.dadosFinanceiros.mensais.idTipoPagamentoEmpresa;
                novoProdutoVeiculo.tipoPagamento =
                  this.dadosFinanceiros.mensais.tipoPagamento;
              } else {
                novoProdutoVeiculo.idTipoPagamentoEmpresa =
                  this.dadosFinanceiros.avista.idTipoPagamentoEmpresa;
                novoProdutoVeiculo.tipoPagamento =
                  this.dadosFinanceiros.avista.tipoPagamento;
              }

              return novoProdutoVeiculo;
            },
          );

          novaProposta.agregados = novaProposta.agregados.map((agregado) => {
            const novoAgregado = { ...agregado };
            novoAgregado.produtosAgregado = novoAgregado.produtosAgregado.map(
              (produtoAgregado) => {
                const novoProdutoAgregado = { ...produtoAgregado };

                if (novoProdutoAgregado.ismensal) {
                  novoProdutoAgregado.idTipoPagamentoEmpresa =
                    this.dadosFinanceiros.mensais.idTipoPagamentoEmpresa;
                  novoProdutoAgregado.tipoPagamento =
                    this.dadosFinanceiros.mensais.tipoPagamento;
                } else {
                  novoProdutoAgregado.idTipoPagamentoEmpresa =
                    this.dadosFinanceiros.avista.idTipoPagamentoEmpresa;
                  novoProdutoAgregado.tipoPagamento =
                    this.dadosFinanceiros.avista.tipoPagamento;
                }

                return novoProdutoAgregado;
              },
            );

            return novoAgregado;
          });

          return novaProposta;
        });

      this.propostasProdutosSelecionadosAtualizados = novaListaPropostas;
    },

    /**
     * Verifica se a opção selecionada é do pagamento do tipo 'Cartão de Crédito'
     * Como a lógica do Cartão de Crédito não está implementada, apaga os dados selecionados e notifica o usuário
     * @param {Object} - Dados do produto e suas formas de pagamento
     */
    verificaCartaoCredito(objProdutoPagamento) {
      if (
        objProdutoPagamento.valorFinal.tipoPagamento === 'Cartão de Crédito'
      ) {
        objProdutoPagamento.valorFinal = null;
        this.$vs.notify({
          position: 'top-center',
          title: 'Aviso',
          text: 'A opção de pagamento com cartão de crédito não está disponível no momento.',
          color: 'warning',
          timer: 10000,
        });
      }
    },

    /**
     * Valida se as formas de pagamento foram preenchidas
     * @return {boolean} - True se foram validados, false se não passou pela validação
     */
    async validaCamposPreenchidos() {
      const formValid = await this.$validator.validateAll();
      if (!formValid) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção!',
          text: this.$validator.errors.items[0].msg,
          color: 'danger',
          timer: 10000,
        });
        return false;
      }
      return true;
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    montaCopiaPropostas(propostas) {
      try {
        const copiaPropostas = deepClone(propostas);

        return copiaPropostas;
      } catch (error) {
        console.error('Erro ao clonar o objeto:', error);
        return null;
      }
    },

    confereGruposDiferentes() {
      this.liberaAcrescimoDesconto = this.listaCopiaPropostas.every(
        (proposta, index, array) => {
          return proposta.idGrupo.id === array[0].idGrupo.id;
        },
      );
    },
    // verificaCartaoCredito() {
    //   this.hasCartaoCredito = false;
    //   this.btnDisabled = false;

    //   this.propostasProdutosSelecionadosAtualizados
    //     .flat()
    //     .forEach((produto) => {
    //       if (produto.valor.tipoPagamento === 'Cartão de Crédito') {
    //         this.hasCartaoCredito = true;

    //         produto.ismensal
    //           ? (this.isCartaoMensal = true)
    //           : (this.isCartaoAvista = true);
    //       }
    //     });
    // },

    // filtraCartoesSelecionados() {
    //   return this.listaCartoes.filter((cartao) => cartao.selecionado == true);
    // },

    // adicionarCartaoLista(value) {
    //   this.listaCartoes.forEach((cartao) => {
    //     cartao.selecionado = false;
    //   });

    //   this.modalFormCartaoCredito = false;
    //   this.listaCartoes.push(value);

    //   this.btnDisabled = false;
    // },

    // selecionaCartao(cartaoSelecionado) {
    //   this.listaCartoes.forEach((cartao) => {
    //     cartao.selecionado = false;
    //   });
    //   cartaoSelecionado.selecionado = true;
    //   this.$vs.loading();
    //   service
    //     .post('Associado', 'AtualizarCartaoAssociadoPrincipal', {
    //       idProspect: this.idProspect,
    //       idAssociadoCartao: cartaoSelecionado.id_associado_cartao,
    //     })
    //     .then(() => {
    //       this.$vs.loading.close();
    //     })
    //     .catch(() => {
    //       this.$vs.loading.close();
    //     });
    // },
  },

  async mounted() {
    this.listaCopiaPropostas = this.montaCopiaPropostas(this.propostas);
    this.confereGruposDiferentes();
    this.montaPropostasProdutosSelecionados();
    this.montaProdutosSelecionadosUnicos();
    await this.buscaFormasPagamento();
    this.calculaValoresTotaisOriginais(
      this.propostasProdutosSelecionadosOriginais,
    );
    this.calculaValoresTotais(this.propostasProdutosSelecionadosOriginais);
  },
};
</script>
